var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 48,
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 408.585,
    x2: 408.707,
    xlinkHref: "#c",
    y1: 539.833,
    y2: 507.755
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 12.217,
    x2: 40.549,
    y1: 12.333,
    y2: 40.883
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.302
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5b5b5b",
    stopOpacity: 0.049
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 409.516,
    x2: 409.516,
    y1: 547.286,
    y2: 500.519
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f3241",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#575c78"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 409.7,
    x2: 409.7,
    xlinkHref: "#c",
    y1: 548.311,
    y2: 499.232
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.95833 0 0 .95833 -367.678 -477.843)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 408.571,
    cy: 523.798,
    fill: "url(#d)",
    r: 21.916,
    stroke: "url(#d)",
    strokeWidth: 2.168
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 8.756a1.92 1.92 0 0 0 -1.916 1.914c0 .527.215 1.006.562 1.353l3.668 3.668a25.471 25.471 0 0 0 -4.365 1.684l-2.154-2.154a15.643 15.643 0 0 0 -2.734-.268c-.86-.003-1.664.08-2.391.256-1.455.35-2.622 1.08-3.275 2.21-.97 1.68-.61 3.865.654 6.07l.972.972c-1.518 2.035-2.324 4.09-2.128 5.879a1.908 1.908 0 0 0 -.588 3.105l11.502 11.557c.753.084 1.435.25 2.193.254 10.976-.01 20.226-8.62 21.057-19.565l-9.116-9.084c-1.084-1.08-2.799-1.606-4.818-1.632l-.002.11-5.768-5.767a1.91 1.91 0 0 0 -1.353-.562z",
    fill: "url(#b)",
    transform: "matrix(1.04348 0 0 1.04348 383.664 498.619)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408.707 499.662c-13.243 0-24 10.757-24 24s10.757 24 24 24 24-10.757 24-24-10.757-24-24-24zm0 2c12.162 0 22 9.838 22 22s-9.838 21.998-22 21.998-21.998-9.836-21.998-21.998 9.836-22 21.998-22z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408.707 507.755c-1.1 0-2 .898-2 1.997 0 1.1.9 2 2 2 .833 0 1.55-.517 1.849-1.245 1.367.786 2.627 2.44 3.55 4.714 1.011 2.49 1.624 5.691 1.624 9.18 0 2.845-.406 5.499-1.104 7.731l.705.22c.724-2.313 1.139-5.036 1.139-7.95 0-3.576-.624-6.862-1.68-9.46-1.005-2.478-2.402-4.335-4.084-5.194a2.004 2.004 0 0 0 -1.999-1.993zm0 .74c.7 0 1.257.558 1.257 1.257 0 .7-.558 1.26-1.257 1.26-.7 0-1.257-.56-1.257-1.26 0-.699.558-1.257 1.257-1.257zm-7.241 5.727a10.529 10.529 0 0 0 -2.495.267c-1.518.366-2.736 1.127-3.418 2.307-1.01 1.751-.635 4.032.683 6.332l.642-.367c-1.244-2.17-1.515-4.155-.685-5.594.56-.97 1.57-1.626 2.952-1.959 1.38-.333 3.119-.327 5.042.023l.132-.73c-1-.182-1.956-.276-2.853-.28zm14.674.022-.008.742c2.441.032 4.245.786 5.062 2.201.56.968.622 2.167.222 3.526-.399 1.359-1.266 2.86-2.525 4.347l.567.477c1.308-1.546 2.23-3.12 2.67-4.614s.388-2.927-.292-4.105c-.994-1.722-3.106-2.54-5.696-2.574zm-3.679.4c-2.418.518-5.053 1.534-7.645 3.03-3.147 1.818-5.713 4.042-7.436 6.292-1.672 2.181-2.56 4.392-2.35 6.312a2.006 2.006 0 0 0 -1.2 1.83c0 1.1.9 1.997 1.999 1.997s1.997-.898 1.997-1.997-.898-2-1.997-2c-.025 0-.047.007-.072.008-.142-1.616.634-3.644 2.21-5.7 1.65-2.155 4.149-4.329 7.22-6.102 2.53-1.46 5.097-2.447 7.429-2.947zm-3.754 8.062c-1.018 0-1.85.833-1.85 1.85s.832 1.851 1.85 1.851 1.85-.833 1.85-1.85-.832-1.85-1.85-1.85zm-9.75 2.856-.548.499c1.651 1.815 3.83 3.567 6.395 5.048 3.057 1.765 6.173 2.862 8.925 3.261 2.602.377 4.88.131 6.48-.823.36.343.843.558 1.376.558 1.1 0 2-.898 2-1.997s-.9-2-2-2-1.997.9-1.997 2c0 .3.07.58.19.835-1.383.796-3.479 1.05-5.943.693-2.639-.382-5.679-1.446-8.662-3.169-2.503-1.445-4.623-3.155-6.216-4.905zm-3.128 5.286c.699 0 1.257.56 1.257 1.26s-.558 1.257-1.257 1.257-1.26-.558-1.26-1.257.56-1.26 1.26-1.26zm25.756 0c.7 0 1.26.56 1.26 1.26s-.56 1.257-1.26 1.257-1.257-.558-1.257-1.257.558-1.26 1.257-1.26zm-18.554 2.036-.697.249c.684 1.91 1.586 3.502 2.662 4.632 1.075 1.13 2.343 1.804 3.705 1.804 1.974 0 3.726-1.398 5.046-3.595l-.634-.381c-1.243 2.069-2.79 3.236-4.412 3.236-1.12 0-2.191-.547-3.17-1.575s-1.842-2.532-2.5-4.37z",
    fill: "url(#a)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectron);
export default __webpack_public_path__ + "static/media/electron.deea6e532f16e1ca74b441226c974e96.svg";
export { ForwardRef as ReactComponent };